// 物码统计
<template>
  <div id="containt" style="padding-left: 10px;">

    <div class="grid-height" style=" height: calc(100vh - -77px);">
      <vxe-grid align="center" :span-method="mergeRowMethod" show-overflow :stripe="true" :border="true" height="100%"
        :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
        @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

        <template #form>
          <div class="clearfix screen-btns" style="margin-top: 3px;">
            <div class="fl">
              <vxe-button status="primary" class="button-sty" icon="el-icon-plus" @click="openEditDialog">导出</vxe-button>
            </div>
            <div class="fr">
              <!--									<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
              <!--										status="primary" plain>重置</vxe-button>-->
              <vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索</vxe-button>
            </div>
          </div>
          <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="requestParam"
            @submit="searchEvent" @reset="searchEvent">
            <vxe-form-item title="供应商编码:" field="name">
              <template v-slot>
                <el-input v-model="searchBarcode" size="small" clearable />
              </template>
            </vxe-form-item>
            <vxe-form-item title="生产批次:" field="name">
              <template v-slot>
                <el-input v-model="searchItemName" size="small" clearable />
              </template>
            </vxe-form-item>
            <vxe-form-item title="配件编码:" field="name">
              <template v-slot>
                <el-input v-model="searchItemName" size="small" clearable />
              </template>
            </vxe-form-item>
          </vxe-form>
        </template>
        <!-- 分页器 -->
        <template #pager>
          <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
        </template>
      </vxe-grid>
    </div>

  </div>
</template>

<script>
// import { initVxeTable } from '@/const/crud/admin/table'
import pager from '@/components/pager/index.vue'
import { initVxeTable } from '@/const/crud/admin/fakeDataTable'

export default {
  name: 'statistics',

  components: { pager },
  data() {
    return {
      getPageDataUrl: '/basic/basCompanyBarcode/getListPage',
      showEdit: false,
      editViewDataUpdateFlag: false,
      activeName: 'second',
      dataId: 0,
      pageSizes: [10, 20, 100],
      requestParam: {
        searchCount: false,  // 是否分页
        itemCode: "",  // 产品编码
        itemName: "",  // 产品名称
        barcode: '',  // 产品条码
        current: 1,  // 当前页面
        size: 10,  // 页面数据量
      },
      searchBarcode: '',
      searchItemCode: '',
      searchItemName: '',
      total: 0,  // 数据总数
      vxeOption: {},
      columns: [
        // { type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left' },

        { title: '供应商编码', field: 'barcode', width: 150, },
        { title: '供应商名称', field: 'supplierName', width: 150, },
        { title: '生产批次', field: 'partsCode', width: 150, },

        ,
        { title: '配件编码', field: 'itemName', width: 150, },
        { title: '配件名称', field: 'Production', width: 150, },


        { title: '采购数量', field: 'encoding', width: 110, },
        { title: '更换数量', field: 'batch', width: 100, },
        { title: '更换率', field: 'order', width: 110, },



        // {
        //   title: '',
        //   children: [
        //     { title: '销售单号', field: 'encoding', width: 80, },
        //     { title: '销售商', field: 'supply', width: 80, },
        //     { title: '销售日期', field: 'instDate', width: 100 },
        //   ]
        // },

        // { width: 47, fixed: 'right', title: '', sortable: false, slots: {
        //     default: ({ row }) => {
        //       return [
        //         <div>
        //           <a
        //             href="javascript:void(0);"
        //             class="a-link"
        //             onclick={() => {
        //               this.openEditDialog(row.id);
        //             }}
        //           >
        //             <el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
        //               <i class="el-icon-edit" />
        //             </el-tooltip>
        //           </a>
        //         </div>
        //       ];
        //     }
        //   }
        // }
      ],
    };
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    }
  },
  methods: {
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      const fields = ['barcode', 'supplierName', 'produceCompany', "itemName", 'Production']
      const cellValue = row[column.property]
      if (cellValue && fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    },
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: this.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        fakeData: {
          total: 0,
          list: [
            { id: 1, barcode: '121219985689635', supplierName: '洲明', partsCode: 'CH958475214', itemName: 'PJ-111111', Production: '铜管', encoding: '100', batch: '2', order: '2%', },
            { id: 2, barcode: '121219985689635', supplierName: '洲明', partsCode: 'CH958475569', itemName: 'PJ-111111', Production: '铜管', encoding: '200', batch: '2', order: '1%', },
            { id: 3, barcode: '121219985689635', supplierName: '洲明', partsCode: 'CH958475214', itemName: 'PJ-111111', Production: '铜管', encoding: '200', batch: '2', order: '1%', },
            { id: 4, barcode: '121219985699999', supplierName: '华帝', partsCode: 'CH958475569', itemName: 'PJ-111112', Production: '水平尺', encoding: '100', batch: '2', order: '2%', },
            { id: 5, barcode: '121219985689666', supplierName: '洲明', partsCode: 'CH958475214', itemName: 'PJ-111113', Production: '保温棉', encoding: '100', batch: '2', order: '2%', },
            { id: 6, barcode: '121219985689666', supplierName: '洲明', partsCode: 'CH958475569', itemName: 'PJ-111113', Production: '保温棉', encoding: '200', batch: '2', order: '1%', },
            { id: 7, barcode: '121219985689666', supplierName: '洲明', partsCode: 'CH958475214', itemName: 'PJ-111113', Production: '保温棉', encoding: '200', batch: '2', order: '1%', },
            { id: 8, barcode: '121219985688888', supplierName: '华帝', partsCode: 'CH958475569', itemName: 'PJ-111114', Production: '温控器', encoding: '200', batch: '2', order: '1%', },
            { id: 9, barcode: '121219985689677', supplierName: '洲明', partsCode: 'CH958475214', itemName: 'PJ-111115', Production: '压缩机', encoding: '200', batch: '2', order: '1%', },
            { id: 10, barcode: '121219985689677', supplierName: '华帝', partsCode: 'CH958475569',itemName: 'PJ-111115', Production: '压缩机', encoding: '100', batch: '2', order: '2%', },
          ]
        },
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    // 搜索
    searchEvent() {
      this.requestParam.barcode = this.searchBarcode
      this.requestParam.itemName = this.searchItemName
      this.requestParam.itemCode = this.searchItemCode
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.searchBarcode = ''
      this.searchItemName = ''
      this.searchItemCode = ''
      this.requestParam.searchCount = false
      this.requestParam.barcode = ''
      this.requestParam.itemCode = ''
      this.requestParam.itemName = ''
      this.requestParam.current = 1
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 新增
    openEditDialog(id) {
      console.log(id)
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
  }
};
</script>
<style lang="scss" >
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
</style>
